
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.667 9L23 14.88M17.667 21L23 14.88m0 0H7","stroke":"#6E88F3","stroke-miterlimit":"10","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M26 1H4v-2h22v2zM1 4v22h-2V4h2zm3 25h22v2H4v-2zm25-3V4h2v22h-2zm-3 3a3 3 0 003-3h2a5 5 0 01-5 5v-2zM1 26a3 3 0 003 3v2a5 5 0 01-5-5h2zM4 1a3 3 0 00-3 3h-2a5 5 0 015-5v2zm22-2a5 5 0 015 5h-2a3 3 0 00-3-3v-2z","fill":"#C7C7C7"}})])
          )
        }
      }
    